import React from "react";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import classNames from "classnames";
import _ from "lodash";
import numeral from "numeral";
import DownloadsModal from "../DownloadsModal";

class ComparativeChart extends React.PureComponent {
  render() {
    const {
      data,
      currentType,
      onCountryChange,
      selectedCountryCode
    } = this.props;

    const colorScale = (value, type) => {
      if (type === "nrw_average") {
        if(value < 0) {
          return "#7f8982";
        }
        if (value > 0 && value < 10) {
          return "#d7e4a8";
        }
        if (value >= 10 && value < 20) {
          return "#b9d263";
        }
        if (value >= 20 && value < 30) {
          return "#a0ba99";
        }
        if (value >= 30 && value < 40) {
          return "#7da579";
        }
        if (value >= 40 && value < 50) {
          return "#54925b";
        }
        if (value >= 50) {
          return "#214525";
        }
      }

      if (type === "extent_of_privatisation") {
        if (value == 0) {
          return "#f4b446";
        }
        if (value >= 0 && value < 25) {
          return "#df8f80";
        }
        if (value >= 25 && value < 50) {
          return "#d4675c";
        }
        if (value >= 50 && value < 75) {
          return "#ca3d3c";
        }
        if (value >= 75) {
          return "#7e1a1a";
        }
      }

      if (type === "sheet_utilities_total") {
        if (value >= 0 && value < 2) {
          return "#df9cc5";
        }
        if (value >= 2 && value < 30) {
          return "#d576ad";
        }
        if (value >= 30 && value < 100) {
          return "#b484ac";
        }
        if (value >= 100 && value < 1000) {
          return "#9e5b91";
        }
        if (value >= 1000 && value < 5000) {
          return "#89357a";
        }
        if (value >= 5000) {
          return "#3b1334";
        }
      }

    };

    const mapValues = () => data.map(d => {
      if (["Guernsey", "Global", "Jersey", "n/a", "Macau"].find(f => d.country_name === f)) {
        return;
      }
      return ({
        code: d.country_id.toUpperCase(),
        name: d.country_name,
        value: Number(d[currentType]),
        accuracy: currentType === "sheet_utilities_total" ? d.sheet_utilities_accuracy : null,
        color: colorScale(Number(d[currentType]), currentType)
      });
    })
    .filter(e => e)
    .sort((a,b) => a.value - b.value)
    .reverse();

    const chartTitle = () => {
      if (currentType === "nrw_average") {
        return "% NRW average";
      } else if (currentType === "sheet_utilities_total") {
        return "Number of utilities";
      } else if (currentType === "extent_of_privatisation") {
        return "% private";
      }
    };

    const highlightCountry = countryCode => {
      return classNames({
        selected: countryCode === selectedCountryCode.toUpperCase()
      });
    };

    return (
      <div className="comparative-list">
        <div className="comparative-list-title">{chartTitle()}</div>
        <DownloadsModal currentType={currentType} countryData={data} forComparative />
        {
          mapValues().map((country, i) => {
            return (
              <div className="comparative-list-item" key={country.code + currentType}>
                <span className="ordinal">{i+1}.</span>
                <span className="flag-wrapper">
                  <ReactCountryFlag
                    countryCode={country.code}
                    svg
                    style={{
                      width: "20px",
                      height: "20px",
                      margin: "0 5px"
                    }}
                    title={country.name}
                  />
                </span>
                <span className={`country-name ${highlightCountry(country.code)}`} onClick={() => onCountryChange(country.code.toLowerCase())}>
                  {_.truncate(country.name, { "length": 10 })}
                </span>
                <span className="country-value" style={{ color: country.color }}>
                  {country.accuracy === "Estimate" && "c."}
                  {(currentType !== "extent_of_privatisation" && country.value <= 0) ? "-" : numeral(country.value).format("0,0")}
                  {currentType !== "sheet_utilities_total" && "%"}
                  {country.accuracy === "At least" && "+"}
                </span>
              </div>
            );
          })
        }
      </div>
    );
  }
}

ComparativeChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentType: PropTypes.string.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  selectedCountryCode: PropTypes.string.isRequired
};

export default ComparativeChart;
